import React, { useState } from 'react';

import Table from '~components/molecules/Table';
import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import {
    GoldTypeEnum,
    SilverTypeEnum,
    TransactionActionEnum,
    TransactionStatusEnum,
} from '~utils/enums';

import UtilFunctions from '~utils/functions';
import * as Styles from './salesReportTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';

const SalesReportTable = () => {
    const {
        Misc: {
            renderTransactionStatusChip,
            dateTimeFormat,
        },
    } = UtilFunctions; 

    const transactionListing = useAppSelector(state => state.report.salesReport.salesReportTransactionListing.data);
    const getTransactionListingAttempt = useAppSelector(state => state.report.loadings.getSalesReportTransactionListing);

    const isLoading = useAppSelector(state => state.report.loadings.getSalesReportTransactionListing);
    const isError = useAppSelector(state => state.report.errors.getSalesReportTransactionListing);

    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);
    const [serialNoList, setSerialNoList] = useState<string[]>([]);

    const tableHeader = [
        'TRANSACTION ID',
        'TRANSACTION ITEM ID',
        'TRANSACTION TYPE',
        'BRANCH',
        'SERIAL NUMBER',
        'PRODUCT NAME',
        'STATUS',
        'GOLD TYPE',
        'SILVER TYPE',
        'TOTAL NET VALUE (RM)',
        'TOTAL NET VALUE PER ITEM (RM)',
        'TOTAL WEIGHT (G)',
        'DESCRIPTION',
        'TOTAL WEIGHT PER UNIT (G)',
        'API BASED PRICE (RM)',
        'DISCOUNT NAME',
        'DISCOUNT CODE',
        'DISCOUNT TYPE',
        'DISCOUNT RATE (%)',
        'FLAT DISCOUNT RATE (RM)',
        'AFFIN SPLIT PER UNIT (RM)',
        'AFFIN SPLIT RATE PER UNIT (%)',
        'AFFIN SPLIT RATE PER UNIT AFTER DISCOUNT (RM)',
        'AFFIN SPLIT RATE PER UNIT AFTER DISCOUNT (%)',
        'MINTING COST PER UNIT',
        'MINTING RATE PER UNIT',
        'TTT SPLIT PER UNIT (RM)',
        'TRANSACTION DATE',
    ];

    let prevTransactionId = 0;
    const tableBody = transactionListing.map(transaction => {
        const {
            transactionId,
            transactionItemId,
            transactionType,
            branchName,
            serialNumbers,
            productName,
            status,
            goldType,
            silverType,
            totalNetValue,
            netValuePerTransactionItem,
            totalWeight,
            description,
            totalWeightPerUnit,
            apiBasedPrice,
            discountName,
            discountCode,
            discountTransactionType,
            discountRatePercentage,
            flatDiscountRate,
            affinSplitPerUnit,
            affinSplitRatePerUnit,
            affinSplitPerUnitAfterDiscount,
            affinSplitRatePerUnitAfterDiscount,
            mintingCostPerUnit,
            mintingRatePerUnit,
            tttSplitPerUnit,
            transactionDate,
        } = transaction;

        const renderTransactionId = () => {
            if (prevTransactionId !== transactionId){
                prevTransactionId = transactionId;
                return transactionId;
            }

            return '-';
        };

        const renderAction = () => {
            if (!transactionType) return '-';

            return TransactionActionEnum[transactionType];
        };

        const metalType =
            goldType ? 'gold' :
                silverType ? 'silver' :
                    '';

        const handleViewSerialNo = () => {
            if (!serialNumbers) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => {
            if (!serialNumbers) return '-';

            return (
                <ActionButton
                    key={transactionId}
                    label='View'
                    onClick={handleViewSerialNo}
                />
            );
        };

        return {
            className:
                metalType === 'gold'
                    ? Styles['gold-row']
                    : '',

            cells: [
                renderTransactionId(),
                transactionItemId,
                (
                    <Text
                        key={transactionId}
                        label={renderAction() || ''}
                        className={Styles['transaction-action-label']}
                        isBold
                    />
                ),
                branchName,
                renderSerialNo(),
                productName,
                renderTransactionStatusChip(status, TransactionStatusEnum[status]),
                goldType ? GoldTypeEnum[goldType].split(/(?=[A-Z])/).join(' ') : '-',
                silverType ? SilverTypeEnum[silverType].split(/(?=[A-Z])/).join(' ') : '-',
                totalNetValue,
                netValuePerTransactionItem,
                totalWeight,
                description,
                totalWeightPerUnit || '-',
                apiBasedPrice,
                discountName,
                discountCode,
                discountTransactionType,
                discountRatePercentage,
                flatDiscountRate,
                affinSplitPerUnit,
                affinSplitRatePerUnit,
                affinSplitPerUnitAfterDiscount,
                affinSplitRatePerUnitAfterDiscount,
                mintingCostPerUnit,
                mintingRatePerUnit,
                tttSplitPerUnit,
                dateTimeFormat(transactionDate),
            ],
        }
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default SalesReportTable;
